var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KButton',{on:{"click":_vm.openModal}},[_vm._v("Open modal")]),_vm._v(" "),(_vm.showModal)?_c('KModal',{attrs:{"title":"Title"},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('KIconButton',{attrs:{"icon":"close"},on:{"click":_vm.closeModal}})]},proxy:true}],null,false,1431279450)}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }